// 乐鸟正式接口
var api = "https://wxapi.lny119.com/";
var sapi = "https://sapi.lny119.com/";
var ceshi = "http://127.0.0.1:5000/";
//AJAX异步请求数据
var doAction = function(url, param, backFun, style) {
  param = JSON.stringify(param);
  var urldata = "";
  if (style == "weixin") {
    urldata = sapi + url;
    console.log(urldata);
  }
  if (style == "wxapi") {
    urldata = api + url;
    console.log(urldata);
  }
  $.ajax({
    type: "post",
    async: true,
    url: urldata,
    dataType: "json",
    data: param,
    contentType: "application/json",
    success: function(result) {
      backFun(result);
    },
    // beforeSend: function (xhr) {
    //   xhr.setRequestHeader("access_token", token);
    // },
    error: function(XMLResponse) {
      if (XMLResponse.status == 401) {
        // showAlert("登录时间过期，请重试");
        sessionStorage.clear();
        // this.$router.push({path:'/Login'});
      } else {
        // showAlert("请求失败，请重试");
      }
      return false;
    }
  });
};

var doActionGet = function(url, param, backFun, style) {
  var urldata = "";
  if (style == "weixin") {
    urldata = api + url;
    console.log(urldata);
  }
  if (style == "dd") {
    urldata = sapi + url;
  }
  if (style == "wxapi") {
    urldata = api + url;
    console.log(urldata);
  }
  //timeout默认未配置，即不启用超时
  $.ajax({
    type: "get",
    async: true,
    url: urldata,
    dataType: "json",
    contentType: "application/json",
    data: param,
    success: function(result) {
      backFun(result);
    },
    // beforeSend: function (xhr) {
    //   xhr.setRequestHeader("access_token",token);
    // },
    error: function(XMLResponse) {
      if (XMLResponse.status == 401) {
        sessionStorage.clear();
      } else {
      }
      return false;
    }
  });
};
var dofeatheraGet = function(url, param, backFun, style) {
  var urldata = "";
  if (style == "weixin") {
    urldata = ceshi + url;
    console.log(urldata);
  }
  if (style == "dd") {
    urldata = sapi + url;
  }
  //timeout默认未配置，即不启用超时
  $.ajax({
    type: "get",
    async: true,
    url: urldata,
    dataType: "json",
    contentType: "application/json",
    data: param,
    success: function(result) {
      backFun(result);
    },
    // beforeSend: function (xhr) {
    //   xhr.setRequestHeader("access_token",token);
    // },
    error: function(XMLResponse) {
      if (XMLResponse.status == 401) {
        sessionStorage.clear();
      } else {
      }
      return false;
    }
  });
};

var dofeathera = function(url, param, backFun, style) {
  param = JSON.stringify(param);
  console.log(param);
  var urldata = "";
  if (style == "weixin") {
    urldata = ceshi + url;
    console.log(urldata);
  }
  $.ajax({
    type: "post",
    async: true,
    url: urldata,
    dataType: "json",
    data: param,
    contentType: "application/json",
    success: function(result) {
      backFun(result);
    },
    // beforeSend: function (xhr) {
    //   xhr.setRequestHeader("access_token", token);
    // },
    error: function(XMLResponse) {
      if (XMLResponse.status == 401) {
        // showAlert("登录时间过期，请重试");
        sessionStorage.clear();
        // this.$router.push({path:'/Login'});
      } else {
        // showAlert("请求失败，请重试");
      }
      return false;
    }
  });
};
export default {
  dofeatheraGet,
  dofeathera,
  doAction,
  doActionGet,
  bindBefore: "wechat/bindBefore", //乐鸟云平台绑定openid前判断
  bindBeforeWithPassword: "wechat/bindBeforeWithPassword", //乐鸟云平台绑定openid前判断
  bindIsOk: "wechat/bindIsOk", //查询openId是否已经绑定
  bindLny: "wechat/bindLny", //乐鸟云平台绑定openId
  removeBindLny: "wechat/removeBindLny", //乐鸟云平台解除绑定openId,
  smsCode: "leniao-ucenter/auth/sms-code", //验证码
  getAccessToken: "leniao-dingding/dingTalk/getAccessToken", //获取钉钉token
  ddIsOk: "leniao-dingding/dingTalk/bindIsOk", //钉钉校验获取id
  ddbindBefore: "leniao-dingding/dingTalk/bindBefore", //校验验证码
  ddbindLny: "leniao-dingding/dingTalk/bindLny", //绑定
  getUserPlatform: "leniao-dingding/dingTalk/getUserPlatform", //钉钉平台获取
  ddremoveBindLny: "leniao-dingding/dingTalk/removeBindLny", //解绑
  getCode: "leniao-ucenter/auth/code", //获取验证码图片
  //预付费
  findProjectInfo: "leniao-wx-pay/deviceInfo/h5/findProjectInfo", //单位查询接口
  findDeviceinfo: "leniao-wx-pay/deviceInfo/h5/findDeviceinfo", //设备查询接口
  realtimeValue: "leniao-wx-pay/deviceInfo/h5/realtimeValue", //实时数据接口
  amountToEle: "leniao-wx-pay/deviceInfo/h5/amountToEle", //金额转电量
  wxPayByh5: "leniao-wx-pay/prepaid/wxPayByh5", //微信H5支付
  infopage: "leniao-wx-pay/recharge-ele-info/page", //列表
  polling: "leniao-wx-pay/deviceInfo/h5/polling", //轮询
  commandpolling: "leniao-iot-web/command/polling", ////轮询
  eleinfoset: "leniao-wx-pay/back-ele-info/set", //退电操作
  eleToAmount: "leniao-wx-pay/deviceInfo/h5/eleToAmount", //电量转钱
  getDeviceInfo: "leniao-wx-pay/deviceInfo/h5/getDeviceInfo", //设备信息
  wxPayRefund: "leniao-wx-pay/prepaid/wxPayRefund", //微信失败调取退款接口

  //新版
  mdbindIsOk: "wechat/md/bindIsOk", //乐鸟云平台绑定openid前判断(new)
  mdbindBefore: "wechat/md/bindBefore", //校验验证码(new)
  mdbindBeforeWithPassword: "wechat/md/bindBeforeWithPassword", //校验验证码(new)
  mdbindLny: "wechat/md/bindLny", //乐鸟云平台绑定openId(new)
  mdremoveBindLny: "wechat/md/removeBindLny", //乐鸟云平台解除绑定openId,

  bindIsBeforeNew: "wechat/md/bindIsBeforeNew", //校验验证码(new)
  bindLnyNew: "wechat/md/bindLnyNew", //乐鸟云平台绑定openId(new)
  wxLogin: "wechat/md/wxLogin", //立即登录

  // 羽枫
  login: "registerdata", //添加用户
  users: "users" //查询所有用户
};



// WEBPACK FOOTER //
// ./src/js/common.js